<div class="d-flex m-0 h-100">
  <div id="side-nav" class="d-none d-lg-block flex-shrink-0 side-nav p-0 pt-1">
    <ul class="nav flex-column">
      <li class="nav-item" *ngFor="let item of linkItems">
        <a class="nav-link" routerLinkActive="active-link" routerLink="{{ item.path }}" data-toggle="collapse"
          (click)="toggle(item)" [routerLinkActiveOptions]="{exact:true}">
          {{ item.text }}
        </a>
        <div *ngIf="item.collapse">
          <div>
            <ul>
              <li *ngFor="let subtitle of item.subtitle">
                <a routerLink="{{ subtitle.path }}"  routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}">{{subtitle.name}}</a>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div id="main-content" class="flex-fill px-3 pt-2">
      <div class="alert alert-warning" *ngIf="showPrintAlert">When printing ACM pages, Chrome or Edge are the only two supported browsers to ensure all information is printed.</div>
      <router-outlet></router-outlet>
  </div>
</div>